const currencySymbols: Record<string, string> = {
  NGN: "₦",
  USD: "$",
  GBP: "£",
  CAD: "C$",
  EUR: "€",
  CNY: "¥",
};

export function getCurrencySymbol(
  currency?: string | null,
  defaultSymbol: string = "₦",
): string {
  if (!currency) return defaultSymbol;
  return currencySymbols[currency] ?? defaultSymbol;
}
